module.exports = __webpack_public_path__ + "static/media/dai.b1e99a44.svg";